import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { getRebuildAPI } from "@rebuild/shared/api";
import { ESTIMATE_KEYS } from "@/hooks/queries/estimates/queryKeys";

const { estimatesControllerArchive } = getRebuildAPI();

export function useArchiveEstimateMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (estimateId: string) => estimatesControllerArchive({ estimateId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ESTIMATE_KEYS.all() });
      toast.success("Project archived");
    },
    onError: () => {
      toast.error("Failed to archive project");
    },
  });
}
